var React = require('react');

function Cv (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"358.94223","height":"478.9422","x":"0.5288924","y":"0.5288924","ry":"36.062447","key":0}),React.createElement("path",{"d":"m 54.75,252 h 249.5","key":1}),React.createElement("path",{"d":"M 55,340 H 305 Z","key":2}),React.createElement("path",{"d":"M 54.75,429 H 305 Z","key":3}),React.createElement("path",{"d":"M 165.00109,64.474261 H 95.475353 V 173.52574 h 69.525737","key":4}),React.createElement("path",{"d":"M 195.45345,64.146004 230.3997,172.41938 264.54567,64.357751","key":5})]);
}

Cv.defaultProps = {"viewBox":"0 0 360 480"};

module.exports = Cv;

Cv.default = Cv;
